import { Component, Input, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { ButtonModule } from 'primeng/button'
import { AffairModel } from '../../../../../core/models/affair.model'
import { TableModule } from 'primeng/table'
import { TagModule } from 'primeng/tag'
import { DatePipe, NgClass } from '@angular/common'
import { InterventionModel } from '../../../../../core/models/intervention.model'
import { environment } from '../../../../../../environments/environment'

@Component({
  selector: 'app-affair-interventions',
  templateUrl: './affair-interventions.component.html',
  styleUrls: ['./affair-interventions.component.scss'],
  standalone: true,
  imports: [ButtonModule, TableModule, TagModule, DatePipe, NgClass],
})
export class AffairInterventionsComponent implements OnInit {
  @Input() affair: AffairModel
  @Input() interventions: InterventionModel[]

  constructor(private router: Router) {}

  ngOnInit(): void {}

  onProgramClicked() {
    this.router.navigate(['/affair/' + this.affair.mlRef + '/schedule'])
  }

  formatDate(dateString: string | Date): string {
    if (!dateString) return 'N/A'
    const date = new Date(dateString)

    // Formatter la date en français
    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }
    return new Date(dateString).toLocaleDateString('fr-FR', options)
  }

  formatTime(dateString: string | Date): string {
    if (!dateString) return ''
    const date = new Date(dateString)

    return date.toLocaleTimeString('fr-FR', {
      hour: '2-digit',
      minute: '2-digit',
    })
  }

  getStatus(intervention: InterventionModel): string {
    const now = new Date()
    const startDate = new Date(intervention.startDate)

    if (intervention.status) {
      return intervention.status
    }

    if (startDate > now) {
      return 'À venir'
    } else {
      return 'Terminée'
    }
  }

  getStatusClass(intervention: InterventionModel): string {
    const status = this.getStatus(intervention)

    switch (status.toLowerCase()) {
      case 'terminée':
        return 'status-completed'
      case 'annulée':
        return 'status-cancelled'
      default:
        return 'status-upcoming'
    }
  }

  viewDetails(intervention: InterventionModel) {
    // Naviguer vers le composant de vue d'intervention
    console.log(intervention)
    this.router.navigate([
      '/intervention',
      intervention.id,
      'view',
      intervention.erpSource,
    ])
  }

  openOnEros(intervention: InterventionModel) {
    const erpSource = intervention.erpSource
    if (erpSource === 'abm') {
      window.open(
        environment.abmUrl + 'interventions/' + intervention.id + '/edit',
        '_blank'
      )
    } else if (erpSource === 'nrj') {
      window.open(
        environment.nrjUrl + 'interventions/' + intervention.id + '/edit',
        '_blank'
      )
    }
  }
}
